import { render, staticRenderFns } from "./Hangman.vue?vue&type=template&id=6c0c3746&scoped=true"
import script from "./Hangman.vue?vue&type=script&lang=js"
export * from "./Hangman.vue?vue&type=script&lang=js"
import style0 from "./Hangman.vue?vue&type=style&index=0&id=6c0c3746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0c3746",
  null
  
)

export default component.exports